// misc
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NotesManager: function() {
        return _notes.default;
    },
    celsiusToFahrenheit: function() {
        return _temperature.celsiusToFahrenheit;
    },
    checkStatusObject: function() {
        return _status.checkStatusObject;
    },
    colormap: function() {
        return _colormap.colormap;
    },
    dataURItoBlob: function() {
        return _images.dataURItoBlob;
    },
    debounce: function() {
        return _debounce.debounce;
    },
    deltaCelsiusToFahrenheit: function() {
        return _temperature.deltaCelsiusToFahrenheit;
    },
    fahrenheitToCelsius: function() {
        return _temperature.fahrenheitToCelsius;
    },
    flatMarkerArray: function() {
        return _markers.flatMarkerArray;
    },
    formatDateTime: function() {
        return _datetime.formatDateTime;
    },
    getAssetsFromURL: function() {
        return _images.getAssetsFromURL;
    },
    getBufferFromPath: function() {
        return _images.getBufferFromPath;
    },
    getCanvasBlob: function() {
        return _images.getCanvasBlob;
    },
    getClientTimeZone: function() {
        return _datetime.getClientTimeZone;
    },
    getDisplayDelta: function() {
        return _temperature.getDisplayDelta;
    },
    getDisplayTemperature: function() {
        return _temperature.getDisplayTemperature;
    },
    getDisplayUnit: function() {
        return _temperature.getDisplayUnit;
    },
    getIRPaletteSetup: function() {
        return _unpackImageInfo.getIRPaletteSetup;
    },
    getIRVIEWERProps: function() {
        return _unpackImageInfo.getIRVIEWERProps;
    },
    getImageInfoByFrameIndex: function() {
        return _getImageInfo.default;
    },
    getInfoTable: function() {
        return _tables.getInfoTable;
    },
    getMarkerById: function() {
        return _markers.getMarkerById;
    },
    getObjectAsJSONFile: function() {
        return _images.getObjectAsJSONFile;
    },
    getReasonIndex: function() {
        return _status.getReasonIndex;
    },
    getStatus: function() {
        return _status.getStatus;
    },
    getStatusCode: function() {
        return _status.getStatusCode;
    },
    getStatusCodes: function() {
        return _status.getStatusCodes;
    },
    getStatusDescription: function() {
        return _status.getStatusDescription;
    },
    getStatusIndex: function() {
        return _status.getStatusIndex;
    },
    getVisibleStandardMarkers: function() {
        return _markers.getVisibleStandardMarkers;
    },
    handleImageExport: function() {
        return _images.handleImageExport;
    },
    handleImageSave: function() {
        return _images.handleImageSave;
    },
    unpackImageInfo: function() {
        return _unpackImageInfo.default;
    },
    zipIS2: function() {
        return _images.zipIS2;
    }
});
const _debounce = require("./debounce.js");
const _colormap = require("./colormap.js");
const _unpackImageInfo = /*#__PURE__*/ _interop_require_wildcard(require("../IRViewer/lib/utils/unpackImageInfo.js"));
const _getImageInfo = /*#__PURE__*/ _interop_require_default(require("../IRViewer/lib/utils/getImageInfo.js"));
const _markers = require("./markers");
const _status = require("./status");
const _notes = /*#__PURE__*/ _interop_require_default(require("./notes"));
const _temperature = require("./temperature.js");
const _images = require("./images");
const _tables = require("./tables");
const _datetime = require("./datetime.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
